'use strict';

var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var InternalFlexBox = require('./InternalFlexBox-BDDWEQ9L.js');

const InternalCluster = react.forwardRef(({ children, justifyContent = 'flex-start', alignItems = 'center', gap = '300', ...flexBoxProps }, ref) => (jsxRuntime.jsx(InternalFlexBox.InternalFlexBox, { ...flexBoxProps, gap: gap, justifyContent: justifyContent, alignItems: alignItems, flexWrap: "wrap", ref: ref, children: children })));
InternalCluster.displayName = 'InternalCluster';

exports.InternalCluster = InternalCluster;
//# sourceMappingURL=InternalCluster-CI9J3-Do.js.map
